import { Outlet } from "react-router-dom"

import { CommandPalette } from "@/components/shell/command-palette"
import { ShellProvider } from "@/providers/shell-provider"

/** Wraps all authenticated routes so ⌘K and shell context work on dashboard and admin. */
export function AuthenticatedShellOutlet() {
  return (
    <ShellProvider>
      <CommandPalette />
      <Outlet />
    </ShellProvider>
  )
}
